import { useState } from "react"

interface ValidationResult {
    valid: boolean
    error?: string
}

type ValidationResults = {
    [field: string]: ValidationResult[]
}

const useFormValidation = (
    initialState,
    initialError,
    validations,
    submitHandler
) => {
    const [state, setState] = useState(initialState)
    const [stateErrors, setStateErrors] = useState(initialError)

    const validate = (form): ValidationResults => {
        const validationResult: ValidationResults = {}

        for (const field in validations) {
            const value = form[field]
            const validationsForField = validations[field]

            validationResult[field] = validationsForField.map(
                ({ validate, errorMessage }) =>
                    validate(value)
                        ? { valid: true }
                        : { valid: false, error: errorMessage }
            )
        }

        return validationResult
    }

    const handleSubmit = async (event) => {
        event.preventDefault()

        const validationResults = validate(state)

        let allValid = true
        const errors = {}

        Object.keys(validationResults).forEach((field) => {
            const errorsForField = validationResults[field].filter(
                (result) => !result.valid
            )

            if (errorsForField.length > 0) {
                errors[field] = errorsForField[0].error
                allValid = false
            }
        })

        if (allValid) {
            await submitHandler(state) // Assuming submitHandler is async
        } else {
            setStateErrors(errors)
        }
    }

    return {
        state,
        setState,
        stateErrors,
        setStateErrors,
        handleSubmit,
    }
}

export default useFormValidation
